import { useEffect, useState } from "react";

export default function InstallPrompt() {
  const [promptEvent, setPromptEvent] = useState<any>(null);
  const [visible, setVisible] = useState(false);
  const [isIos, setIsIos] = useState(false);

  useEffect(() => {
    // Innerhalb der nativen App kein Install-Prompt anzeigen
    if ((window as any).ReactNativeWebView) return;

    const shownCount = parseInt(
      localStorage.getItem("installPromptShown") || "0",
      10
    );

    // Nur wenn weniger als 2x gezeigt wurde
    if (shownCount >= 2) {
      return;
    }

    const isIOSDevice = /iphone|ipad|ipod/.test(
      window.navigator.userAgent.toLowerCase()
    );
    const isStandalone =
      "standalone" in window.navigator && (window.navigator as any).standalone;

    if (isIOSDevice && !isStandalone) {
      setIsIos(true);
      setVisible(true);
      localStorage.setItem("installPromptShown", (shownCount + 1).toString());
    }

    window.addEventListener("beforeinstallprompt", (e: any) => {
      e.preventDefault();
      setPromptEvent(e);
      setVisible(true);
      localStorage.setItem("installPromptShown", (shownCount + 1).toString());
    });
  }, []);

  const handleInstall = () => {
    if (promptEvent) {
      promptEvent.prompt();
      promptEvent.userChoice.then(() => {
        setPromptEvent(null);
        setVisible(false);
      });
    }
  };

  const closeBanner = () => {
    setVisible(false);
  };

  if (!visible) {
    return null;
  }

  return (
    <div className="fixed top-0 left-0 right-0 bg-blue-600 text-white p-4 flex justify-between items-center shadow-xl z-50">
      {isIos ? (
        <>
          <span className="text-sm">
            Tippe auf <strong>Teilen</strong> und dann auf{" "}
            <strong>„Zum Home-Bildschirm“</strong>.
          </span>
          <button
            className="bg-white text-blue-600 px-3 py-1 rounded ml-2 text-sm font-semibold"
            onClick={closeBanner}
          >
            OK
          </button>
        </>
      ) : (
        <>
          <span className="text-sm">
            Svevana installieren und einfacher planen!
          </span>
          <button
            className="bg-white text-blue-600 px-3 py-1 rounded ml-2 text-sm font-semibold"
            onClick={handleInstall}
          >
            Installieren
          </button>
        </>
      )}
    </div>
  );
}
